
/**
 * Custom component for wine list menu items.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.2.3
 * @copyright  Copyright (C) 2022-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2022-10-04 (1.0.0) (jhoward)
 *      - Menu item layout refactored to <wineListItem> for wine list section components.
 *
 *    2022-10-26 (1.0.1) (jhoward)
 *      - <wineListItem> now allows HTML in item titles.
 *
 *    2023-04-17 (1.1.0) (jhoward)
 *      - Refactor <wineListItem> to use TypeScript.
 *      - <wineListItem> sets the default value for a pricing type to a blank string.
 *
 *    2023-06-19 (1.1.1) (jhoward)
 *      - <wineListItem> set to not include denomination when outputting prices.
 *
 *    2023-06-21 (1.1.2) (jhoward)
 *      - Make sure <wineListItem> displays a price even if no pricing types are given.
 *
 *    2023-09-08 (1.2.0) (jhoward)
 *      - Refactor <wine-list-item> to use <default-item> component.
 *
 *    2023-09-13 (1.2.1) (jhoward)
 *      - Set hideDenomination prop for <default-item> component.
 *
 *    2023-09-21 (1.2.2) (jhoward)
 *      - Set isGroupedByPrice prop for <default-item> in <wine-list-item>.
 *
 *    2025-04-08 (1.2.3) (jhoward)
 *      - Remove handing of "maxItemRows" in <wine-list-item>.
 *      - Remove "visual_" prefix from class names in <wine-list-item>.
 */

import {defineComponent, PropType} from "vue";
import MenuTag from "../menu-tag.vue";
import {
  methodGetItemBIN,
  methodRemoveBINFromTitle,
} from "../../../helpers/menu-sections";
import {MenuItem} from "../defs";
import DefaultItem from "./defaultItem.vue";

export default defineComponent({
  name: 'wineListItem',
  components: {
    DefaultItem,
    MenuTag
  },
  props: {
    item: {
      type: Object as PropType<MenuItem>,
      required: true
    },
    showBin: {
      type: Boolean,
      default: false
    },
    pricingTypes: {
      type: Array as PropType<string[]>,
      default: []
    },
    isGroupedByPrice: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    itemId: function () {
      return this.item.mi_id || 0;
    }
  },
  methods: {
    getItemBIN: methodGetItemBIN,
    removeBINFromTitle: methodRemoveBINFromTitle,

    handleItemRows(rows: number) {
      this.$emit('rows', rows);
    },
  }
})
